/**
 * 基于表达式生成页脚
 */
import { getJsonAta } from '@/utils/jsonataFactory';
import React from 'react';
import useValuesStore from '@/store/useValuesStore';

export function useFooter({
  footerExpression,
  value,
}: {
  footerExpression: string;
  value: any;
}) {
  const { values } = useValuesStore();
  if (footerExpression) {
    const jsonata = getJsonAta(footerExpression);
    let res = footerExpression;
    try {
      res = jsonata.evaluate({ ...values, ...value });
    } catch (e) {
      console.error(`表格页尾自定义文案解析失败 - ${footerExpression}`, e);
      res = '';
    }
    return () => (
      <div style={{ lineHeight: '42px', whiteSpace: 'break-spaces' }}>{res}</div>
    );
  }
  return null;
}
